const DEVELOPMENT_CAPACITY_SCALING = {
  name: 'DEVELOPMENT CAPACITY SCALING:',
  type: 'SIMPLE_LIST',
  links: [
    {
      name: 'Dedicated Teams',
      url: '/services/development-teams/',
    },
    {
      name: 'Team Augmentation',
      url: '/services/team-augmentation/',
    },
    {
      name: 'Product Creation',
      url: '/services/product-design-and-development/',
    },
  ],
};

const CLAUDE_CODE_EXPERTS_BANNER = {
  type: 'SPECIAL_SERVICE',
  label: 'High-demand Service',
  title: 'Claude Code Experts - AI-Powered Development Services',
  description:
    'Expert consulting for Claude Code adoption, AI-assisted development workflows, and team productivity optimization',
  icon: 'megaphone',
  url: '/services/claude-code-experts/',
};

export const DIGITAL_PRODUCT = {
  name: 'Digital Product',
  categories: [
    {
      type: 'ICON_LIST',
      name: 'DIGITAL PRODUCT SERVICES:',
      links: [
        {
          name: 'Software Development',
          description:
            'Web development, Mobile Development, No Code Development, Custom Application Development',
          icon: 'phone',
          url: '/services/software-development-outsourcing/',
        },
        {
          name: 'Product Innovation & Strategy',
          description:
            'User Research & Testing, Product Discovery, Product Strategy & Roadmap, AI Strategy and Roadmap',
          icon: 'papers',
          url: '/services/product-innovation-and-strategy/',
        },
        {
          name: 'Digital Design',
          description:
            'Product Design, UI/UX Design, Design Systems Digital Prototyping',
          icon: 'hand',
          url: '/ux-ui-design-consulting-services/',
        },
        {
          name: 'DevOps & Infrastructure',
          description:
            'Cloud Services, Continuous Integration and Continuous Deployment, Infrastructure Automation, Containerization',
          icon: 'plane',
          url: '/services/devops-consulting-services/',
        },
        {
          name: 'Agile Coaching Services',
          description:
            'Quality Assurance, Agile Project Management, Product Management',
          icon: 'car',
          url: '/services/agile-coaching-services/',
        },
        {
          name: 'Consulting & Scaling',
          description:
            'Agile Teams Scaling, Delivery Consulting, CTO as a Service, AI Implementation',
          icon: 'satellite',
          url: '/services/consulting-and-scaling',
        },
        {
          name: 'Testing & Quality',
          description:
            'Automated Testing, Code Audit and UX Audit, Test Strategy and Planning',
          icon: 'ufo',
          url: '/services/testing-and-quality/',
        },
      ],
    },
    DEVELOPMENT_CAPACITY_SCALING,
  ],
  banner: CLAUDE_CODE_EXPERTS_BANNER,
};

export const AI_SERVICES = {
  name: 'AI Services',
  categories: [
    {
      type: 'ICON_LIST',
      name: 'AI & AUTOMATION SERVICES:',
      links: [
        {
          name: 'AI Product Development & Consulting',
          icon: 'magnifier',
          url: '/services/ai-product-development/',
        },
        {
          name: 'MCP Server Development',
          icon: 'mcp-server-development',
          url: '/services/mcp-server-development/',
        },
        {
          name: 'Vibe Coding Sprint',
          icon: 'vibe-coding-sprint',
          url: '/services/vibe-coding-sprint/',
        },
        {
          name: 'Agentic AI Implementation',
          icon: 'agentic-ai-implementation',
          url: '/services/agentic-ai-implementation/',
        },
        {
          name: 'LLM Integration & API Development',
          icon: 'llm-integration-api-development',
          url: '/services/llm-integration-services/',
        },
        {
          name: 'AI Adoption for Engineering Organizations',
          icon: 'ai-adoption-for-engineering-organizations',
          url: '/services/ai-adoption-engineering/',
        },
        {
          name: 'Legacy Code Modernization with AI',
          icon: 'legacy-code-modernization-with-ai',
          url: '/services/legacy-modernization-with-ai/',
        },
        {
          name: 'AI-Powered QA & Test Automation',
          icon: 'ai-powered-qa-test-automation',
          url: '/services/ai-augmented-testing/',
        },
        {
          name: 'AI Workflow Automation for Software Teams',
          icon: 'ai-workflow-automation-for-software-teams',
          url: '/services/ai-workflow-automation/',
        },
        {
          name: 'Sales AI Enablement',
          icon: 'sales-ai-enablement',
          url: '/services/sales-ai-enablement/',
        },
      ],
    },
    DEVELOPMENT_CAPACITY_SCALING,
  ],
  banner: CLAUDE_CODE_EXPERTS_BANNER,
};

export const DESIGN_UX = {
  name: 'Design & UX',
  categories: [
    {
      type: 'ICON_LIST',
      name: 'DESIGN & UX:',
      links: [
        {
          name: 'Product Discovery',
          icon: 'worktable',
          url: '/services/product-discovery/',
        },
        {
          name: 'Modality Discovery Workshop',
          icon: 'fattelescope',
          url: '/services/modality-discovery-workshop/',
        },
        {
          name: 'AI UX – Human-AI Interaction Design',
          icon: 'mountain-hand',
          url: '/services/ai-ux-design/',
        },
        {
          name: 'Interaction Design & Motion',
          icon: 'camera-rolling',
          url: '/services/interaction-design/',
        },
        {
          name: 'Design System as Service',
          icon: 'typewriter',
          url: '/services/design-system/',
        },
        {
          name: 'Outcome-Driven Design Partnership',
          icon: 'rocketride',
          url: '/services/outcome-driven-design-partnership/',
        },
      ],
    },
    DEVELOPMENT_CAPACITY_SCALING,
  ],
  banner: CLAUDE_CODE_EXPERTS_BANNER,
};

export const KNOWLEDGE_HUB = {
  name: 'Knowledge hub',
  categories: [
    {
      name: 'FEATURED BLOG POSTS:',
      type: 'FEATURED_LIST',
      links: [
        {
          name: 'Claude Code vs Cursor: Which AI tool actually fits enterprise reality?',
          description:
            'If you manage engineering teams, you have probably already heard both names. Claude Code and Cursor are two of the most talked-about AI coding tools...',
          image:
            'https://res.cloudinary.com/de4rvmslk/image/upload/w_300/f_auto,q_auto/v1774527423/Frame_2087325362_vvq2o7.png',
          alt: 'Claude Code vs Cursor comparison for enterprise engineering teams',
          url: '/blog/claude-code-vs-cursor-enterprise/',
        },
        {
          name: 'What makes a software development partner truly AI-native? A 2026 guide for CTOs',
          description:
            'If you are a scaleup evaluating software development partners in 2026, nearly every vendor will claim to be AI-powered. Far fewer are genuinely on the path to AI-native...',
          image:
            'https://res.cloudinary.com/de4rvmslk/image/upload/w_300/f_auto,q_auto/v1771936236/blog_vywsgo.png',
          alt: 'Guide for CTOs on choosing an AI-native software development partner',
          url: '/blog/ai-native-delivery-partner-guide/',
        },
      ],
    },
    {
      name: 'RESOURCES:',
      type: 'SIMPLE_LIST',
      links: [
        {
          name: 'Blog',
          url: '/blog/',
        },
        {
          name: 'Videos',
          url: 'https://www.youtube.com/channel/UCOTEkbD0MSAmBzGFNrnRaxQ',
        },
        {
          name: 'Podcasts',
          url: 'https://open.spotify.com/show/3VpRL4e89G681woPahmC1L?si=5036bd5f10ea4642',
        },
        {
          name: 'Boldare boards',
          url: 'https://boards.boldare.com/',
        },
      ],
    },
    {
      name: 'KNOWLEDGE HUB:',
      type: 'SIMPLE_LIST',
      links: [
        {
          name: 'Newsletter',
          url: '/apb-community-newsletter/',
        },
      ],
    },
  ],
};

export const CASE_STUDIES = {
  name: 'Case studies',
  url: '/work/',
};

export const ABOUT_US = {
  name: 'About us',
  url: '/about/',
};

export const NAVIGATION_ITEMS = [
  DIGITAL_PRODUCT,
  AI_SERVICES,
  DESIGN_UX,
  CASE_STUDIES,
  ABOUT_US,
  KNOWLEDGE_HUB,
];

export const shouldRenderSpecialServiceBanner = (bannerData, category) => {
  return (
    bannerData &&
    category &&
    [
      'AI & AUTOMATION SERVICES:',
      'DESIGN & UX:',
      'DIGITAL PRODUCT SERVICES:',
    ].includes(category.name)
  );
};
